import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { AutoComplete } from "primeng/autocomplete";
import { SubSink } from "subsink";
import { ArrayHelper } from "../../../utilities/contracts/array-helper";
import { DynamicControlDirective } from "../../dynamic-control-component.model";
import { DynamicFormEvent } from "../../dynamic-form-event.model";
import { FormService } from "../../form.service";
import { SelectableInput } from "../selectable-input.model";
import { Autocomplete } from "./autocomplete.model";

@Component({
  selector: "app-autocomplete",
  templateUrl: "./autocomplete.component.html",
  styleUrls: ["./autocomplete.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AutocompleteComponent extends DynamicControlDirective<Autocomplete> implements OnInit, AfterViewInit, OnDestroy {
  private sink = new SubSink();
  filteredOptions: SelectableInput[] = [];
  @ViewChild(AutoComplete, { static: true }) primeAutocomplete: AutoComplete;

  get isDropdownEnabled(): boolean {
    return !this.model.readonly && this.model.showDropdownArrow;
  }

  constructor(
    private readonly changeDetector: ChangeDetectorRef,
    private readonly formService: FormService
  ) {
    super();
  }

  ngOnInit() {
    this.sink.add(
      this.control.statusChanges.subscribe(() => this.formService.updateDom.next()),
      this.formService.updateDom.subscribe(() => this.changeDetector.markForCheck())
    );
  }

  ngOnDestroy() {
    this.sink.unsubscribe();
  }

  ngAfterViewInit() {
    this.sink.add(
      this.primeAutocomplete.onSelect.subscribe(value => this.onChange.next(new DynamicFormEvent({
        key: this.model.key,
        type: "notify",
        value,
        control: this.control,
        model: this.model,
      }))),
      this.primeAutocomplete.onUnselect.subscribe(value => this.onChange.next(new DynamicFormEvent({
        key: this.model.key,
        type: "notify",
        value,
        control: this.control,
        model: this.model,
      })))
    );

    if (this.primeAutocomplete.dropdownButton != null) {
      this.primeAutocomplete.dropdownButton.nativeElement.tabIndex = -1;
    }

    if (this.model.hasServerFilter) {
      this.filterOptions({ query: this.model.value });
    }
  }


  get classes(): any {
    return this.getClasses("autocomplete");
  }

  get hasOptions(): boolean {
    return this.model.hasServerFilter || ArrayHelper.isAvailable(this.model.options);
  }

  filterOptions(event): void {
    if (this.model.hasServerFilter) {
      this.model.serverFilter(event.query, this.assignToFilterOptions.bind(this));
    } else {
      this.filteredOptions = this.model.options.filter(item => this.filter(item, event.query));
    }
  }

  private assignToFilterOptions(options: SelectableInput[]): void {
    this.filteredOptions = options;

    // HACK: If the query returns 1 value then select as the value.
    const firstOption = this.filteredOptions.length === 1 ? this.filteredOptions[0] : null;
    if (firstOption != null && firstOption.value === this.model.value) {
      this.control.setValue(firstOption);
    }

    this.changeDetector.markForCheck();
  }

  private filter = (item: SelectableInput, query: string): boolean => {
    return this.model.filter
      ? this.model.filter(item, query)
      : this.contains(item, query);
  }

  private contains(item: SelectableInput, query: string): boolean {
    return item.text.toLowerCase().indexOf(query.toLowerCase()) >= 0;
  }


  onEvent(event) {
    this.onChange.emit(event);
    this.onInput.emit(event);
  }
}
